<template>
  <section>
    <el-select :value="label" placeholder="请选择公司" ref="select" :clearable="true" @clear="doClear" :disabled="isDisabled">
      <el-option :value="id" :label="label">
        <el-tree id="tree-option"
                 ref="selectTree"
                 :data="data"
                 :props="defaultProps"
                 :node-key="defaultProps.value"
                 :default-expanded-keys="defaultExpandedKey"
                 @node-click="handleNodeClick"
                 :load="loadNode1"
                 :default-expand-all="true"
                 :expand-on-click-node="false"
                 lazy
        >
        </el-tree>
      </el-option>
    </el-select>
  </section>
</template>
<script>
  import {comChildren,comDetail} from '../../api/api'

  export default {
    name: 'CompanyTree',
    props: {
      comList: Array,//公司集合
      comId: null,//公司编号
      comName: {
        type: String,
        default: () => {
          return ''
        }
      },//公司名
      currentId: null,//当前公司编号
      option: null,//当前操作  0 公司添加 9 公司修改 （一般1未修改操作因为公司列表组件 需要应用到不到位置 因此 修改操作改成9）
      isDisabled:false,
    },
    data() {
      return {
        //选择树==============================
        data: [],
        defaultProps: {
          children: 'children',
          label:
            'comName',
          value:
            'id',
          disabled: 'disabled'
        },
        id: null,
        label: null,
        defaultExpandedKey: [],
        //====选择树结束=================
      }
    },
    methods: {
      //选择树==================================================================
      //加载数据
      loadNode1(node, resolve) {
        //初始化公司集合树 如果当前登录用户有公司（一般都会有） 以当前登录用户公司为根节点 加载下级公司树
        // let comId = this.GLOBAL.user.comId;
        // if (comId == null || comId == '') {
        //   comId = 0;
        // }
        if (node.level > 0) {
          let comId = node.key;
          let params = {page: 1, limit: 10000, id: comId};//请求参数
          comChildren(params, this.GLOBAL.header).then(result => {
            if (result.success) {
              return resolve(result.data)
            }
          });
        }
      },
      // 切换选项
      handleNodeClick(data,node,self) {
        //当操作是修改时 用户选择的上级公司不能是自己 也不能是自己的下级公司做为修改的上级公司
        //如果允许修改 会造成数据错乱  公司修改操作代码为 9 一般为1
        if(this.option==9){
          let p = node.parent;
          //while条件 是为了找到当前选中的上级公司 是否为当前公司的下级
          while(p!=null){
            if(p.key == this.currentId){
              this.$message({
                message: "不能选择下级公司作为上级",
                type: 'error'
              });
              return;
            }
            p = p.parent;
          }
          if (data.id == this.currentId) {
            this.$message({
              message: "不能选择自己作为上级",
              type: 'error'
            });
            return ;
          }
        }
        this.label = data.comName;
        this.id = data.id;
        this.$emit('comSelected', this.id, this.label);//将当前选定的值传给父级组件
      },
      //选择树结束==============================
      doClear: function () {
        //如果是添加操作 首先以当前用户的公司 为根节点 如果没有 统一设定为 系统根节点 父级值为 0
        if (this.option==0) {
          let comId = this.GLOBAL.user.comId;
          if (comId != null) {
            this.label = this.GLOBAL.user.comName;
            this.id = this.GLOBAL.user.comId;
          } else {
            this.label = '无';
            this.id = 0;
          }
        }else {
          this.label = this.comName;
          this.id = this.comId;
        }
        this.$emit('comSelected', this.id, this.label);//将当前选定的值传给父级组件
      }
    },
    mounted() {
      let params = {id:this.GLOBAL.user.comId};//请求参数

      comDetail(params, this.GLOBAL.header).then(result => {
        if (result.success) {
          if(result.data !=null){
            this.data.push(result.data);
          }else{
            this.data.push({id:0,comName:'无'})
          }

          if (this.option==0) {
            let comId = this.GLOBAL.user.comId;
            if (comId != null) {
              this.label = this.GLOBAL.user.comName;
              this.id = this.GLOBAL.user.comId;
            }else{
              this.label = '无';
              this.id = 0;
            }
          } else {
            this.label = this.comName;
            this.id = this.comId;
          }
          this.$emit('comSelected', this.id, this.label);
        }
      });
    }
  }
</script>

<style scoped>
  /*选择树================================*/
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
    height: auto;
    max-height: 274px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }

  .el-select-dropdown__item.selected {
    font-weight: normal;
  }

  ul li >>> .el-tree .el-tree-node__content {
    height: auto;
    padding: 0 20px;
  }

  .el-tree-node__label {
    font-weight: normal;
  }

  .el-tree >>> .is-current .el-tree-node__label {
    color: #409EFF;
    font-weight: 700;
  }

  .el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
    color: #606266;
    font-weight: normal;
  }

  /*选择树================================*/
</style>



// WEBPACK FOOTER //
// src/components/sysmanager/CompanyList.vue